import { ComponentType, FC, PropsWithChildren, useMemo } from 'react';
import { FallbackProps } from 'react-error-boundary';
import { useLocation } from 'react-router';

import { SchedulerErrorBoundary } from './error-boundary';
import { ErrorBoundaryFallback } from './fallback';

interface Props {
    fallbackComponent?: ComponentType<FallbackProps>;
}

const SchedulerErrorBoundaryWithRouter: FC<PropsWithChildren<Props>> = ({
    fallbackComponent = ErrorBoundaryFallback,
    children,
}) => {
    const location = useLocation();
    const resetKeys = useMemo(() => [location.pathname], [location.pathname]);

    return (
        <SchedulerErrorBoundary resetKeys={resetKeys} fallbackComponent={fallbackComponent}>
            {children}
        </SchedulerErrorBoundary>
    );
};

export { SchedulerErrorBoundaryWithRouter };
